import { render } from "./WCMobileSubpageHeader.vue?vue&type=template&id=bd86e230&scoped=true"
import script from "./WCMobileSubpageHeader.vue?vue&type=script&lang=js"
export * from "./WCMobileSubpageHeader.vue?vue&type=script&lang=js"

import "./WCMobileSubpageHeader.vue?vue&type=style&index=0&id=bd86e230&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd86e230"]])

export default __exports__